<template>
    <!-- 集中式收房合约详情 -->
    <div id="jzsContractDetail">
        <!-- 详情 -->
        <van-tabs v-model="active" class="tabs" v-if="type == 0">
            <van-tab title="合约详情">
                <div class="title">
                    <i class="iconfont iconbookmark"></i> 基本信息
                </div>
                <van-cell title="合约编号" :value="jzsContractDetail.contract.number" />
                <van-cell title="合约状态" :value="pContractStatusList[jzsContractDetail.contract.status-1]" />
                <div class="title">
                    <i class="iconfont iconbookmark"></i> 项目信息
                </div>
                <van-cell title="项目名称" :value="jzsContractDetail.community.name" />
                <van-cell title="项目编码" :value="jzsContractDetail.community.number" />
                <van-cell title="地址" :value="jzsContractDetail.community.address" />
                <div class="title">
                    <i class="iconfont iconbookmark"></i> 业主信息
                </div>
                <van-cell title="业主姓名" :value="jzsContractDetail.property.name" />
                <van-cell title="业主电话" class="space_bet" >
                       <template #right-icon>
                        <a  class="tel" :href="'tel:'+jzsContractDetail.property.phone">
                        <van-icon name="phone" class="search-phone" color="#fd7e2d"  />
                        拨打
                        </a>
                    
                    </template>
                </van-cell>
                <van-cell title="证件号码" v-if="jzsContractDetail.contract.status>=1 && jzsContractDetail.contract.status<=3" :value="'【'+idTypeList[jzsContractDetail.property.idType-1]+'】'+jzsContractDetail.property.idNo" />
                <van-cell title="紧急联系人"  :value="'【'+contactList[jzsContractDetail.property.contactRelation-1]+'】'+jzsContractDetail.property.contactName" />
                <van-cell title="紧急联系人电话" class="space_bet" >
                      <template #right-icon>
                        <a  class="tel" :href="'tel:'+jzsContractDetail.property.contactPhone">
                        <van-icon name="phone" class="search-phone" color="#fd7e2d"  />
                        拨打
                        </a>
                    
                    </template>
                </van-cell>
                <div class="title">
                    <i class="iconfont iconbookmark"></i> 签约信息
                </div>
                <van-cell title="开始日期" :value="jzsContractDetail.contract.startDate?jzsContractDetail.contract.startDate.slice(0,10):''" />
                <van-cell title="租期" :value="jzsContractDetail.contract.leaseMonth?jzsContractDetail.contract.leaseMonth+'月':''+jzsContractDetail.contract.leaseDay?jzsContractDetail.contract.leaseDay+'天':''" />
                <van-cell title="结束日期" :value="jzsContractDetail.contract.endDate?jzsContractDetail.contract.endDate.slice(0,10):''" />
                <van-cell title="交房日期" :value="jzsContractDetail.contract.makeDate?jzsContractDetail.contract.makeDate.slice(0,10):''" />
                <van-cell title="生效日期" :value="jzsContractDetail.contract.activeDate?jzsContractDetail.contract.activeDate.slice(0,10):''" />
                <van-cell title="承租方式" :value="jzsContractDetail.contract.tenantType == 1? '包租':jzsContractDetail.contract.tenantType == 2?'托管':''" />
                <div v-if="jzsContractDetail.contract.tenantType==2">
                    <van-cell title="保底出租日期" :value="jzsContractDetail.contract.guaranteedDate?jzsContractDetail.contract.guaranteedDate.slice(0,10):''" />
                    <van-cell title="参考租金价格" :value="jzsContractDetail.contract.referencePrice" class="border" />
                </div>
                <div v-if="jzsContractDetail.contract.tenantType==1">
                    <van-cell title="免租方式" :value="jzsContractDetail.contract.freeType == 1?'前置免租期':'每年免租期'" />
                    <van-cell title="免租总天数" :value="jzsContractDetail.contract.freeTotalDays" class="border" />
                    <van-collapse v-model="activeNames">
                        <van-collapse-item title="每年约定租期" name="1">
                            <div v-for="(item,index) in jzsContractDetail.propertyContractRentPeriodList || []" :key="index">
                                <div class="van-cell">
                                    <div class="van-cell__title">第 {{index+1}} 年</div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title">时间</div>
                                    <div class="van-cell__value">{{item.startDate?item.startDate.slice(0,10):''}}到{{item.endDate?item.endDate.slice(0,10):''}}</div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title">免租期（天）</div>
                                    <div class="van-cell__value">{{item.freeDays}}</div>
                                </div>
                                <div class="van-cell border1">
                                    <div class="van-cell__title">月租金</div>
                                    <div class="van-cell__value">{{item.monthPrice}}</div>
                                </div>
                            </div>
                        </van-collapse-item>
                    </van-collapse>
                </div>
                <van-cell border title="付款方式" :value="'付'+jzsContractDetail.contract.payMonth+'押'+jzsContractDetail.contract.depositMonth" />
                <van-cell title="押金" :value="jzsContractDetail.propertyReceipt.deposit" />
                <van-cell title="支付方式" :value="payTypeList[jzsContractDetail.propertyReceipt.payType-1]" />
                <van-cell title="收款人姓名" :value="jzsContractDetail.propertyReceipt.accountName" />
                <van-cell title="收款账号" :value="jzsContractDetail.propertyReceipt.bankAccount" />
                <van-cell title="开户行" :value="jzsContractDetail.propertyReceipt.bankName" v-if="jzsContractDetail.propertyReceipt.payType == 3 ||jzsContractDetail.propertyReceipt.payType==4" />
                <van-cell title="支行名称" :value="jzsContractDetail.propertyReceipt.bankBranchName" v-if="jzsContractDetail.propertyReceipt.payType == 3 ||jzsContractDetail.propertyReceipt.payType==4" />
                <van-cell title="电卡" :value="jzsContractDetail.contract.electricCard" />
                <van-cell title="水卡" :value="jzsContractDetail.contract.waterCard" />
                <van-cell title="燃气卡" :value="jzsContractDetail.contract.gasCard" />
                <van-cell title="创建人" :value="jzsContractDetail.contract.creator" />
                <van-cell title="创建日期" :value="jzsContractDetail.contract.createDate" />
            </van-tab>
            <van-tab title="已签房源" class="assets">
                <div v-for="item in jzsContractDetail.houseBuilding" :key="item.id">
                    <div v-for="(item1,index1) in item.houseBuildingItems" :key="index1">
                        <div class="title" v-if="item1.show">
                            <i class="iconfont iconbookmark"></i>
                            {{item.buildingNo+buildingTypeList[item.buildingType-1]+item1.level+"层"}}&ensp;
                        </div>
                        <div class="assetsBody" v-if="item1.show">
                            <div v-for="(item2,index2) in item1.roomInfo" :key="index2" :style="item2.isSign && jzsContractDetail.contractId == item2.communityContractId?'':'display:none'">{{item2.number}}（{{item2.houseTypeName}}）</div>
                        </div>
                    </div>
                </div>
                <van-empty v-if="!jzsContractDetail.houseBuilding.length" description="暂无数据" />
            </van-tab>
            <van-tab title="附件信息">
                <div>
                    <div class="title">
                        <i class="iconfont iconbookmark"></i>
                        业主身份证&ensp;
                    </div>
                    <div class="imgBody">
                        <div class="imgCard">
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsContractDetail.image.idCardFront]">
                                <van-image width="3rem" height="3rem" :src="jzsContractDetail.image.idCardFront" />
                            </div>
                            <div class="text">正面</div>
                        </div>
                        <div class="imgCard">
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsContractDetail.image.idCardBack]">
                                <van-image width="3rem" height="3rem" :src="jzsContractDetail.image.idCardBack" />
                            </div>
                            <div class="text">反面</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="title">
                        <i class="iconfont iconbookmark"></i>
                        电度数&ensp;
                    </div>
                    <div class="imgBody imgBody1">
                        <div class="imgCard">
                            <div class="text">电峰</div>
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsContractDetail.image.electricMax]">
                                <van-image width="3rem" height="3rem" :src="jzsContractDetail.image.electricMax" />
                            </div>
                            <div class="text">{{jzsContractDetail.contract.electricMax}}</div>
                        </div>
                        <div class="imgCard">
                            <div class="text">电谷</div>
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsContractDetail.image.electricMin]">
                                <van-image width="3rem" height="3rem" :src="jzsContractDetail.image.electricMin" />
                            </div>
                            <div class="text">{{jzsContractDetail.contract.electricMin}}</div>
                        </div>
                        <div class="imgCard">
                            <div class="text">电总</div>
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsContractDetail.image.electricTotal]">
                                <van-image width="3rem" height="3rem" :src="jzsContractDetail.image.electricTotal" />
                            </div>
                            <div class="text">{{jzsContractDetail.contract.electricTotal}}</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="title">
                        <i class="iconfont iconbookmark"></i>
                        水度数&ensp;
                    </div>
                    <div class="imgBody">
                        <div class="imgCard">
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsContractDetail.image.water]">
                                <van-image width="3rem" height="3rem" :src="jzsContractDetail.image.water" />
                            </div>
                            <div class="text">{{jzsContractDetail.contract.water}}</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="title">
                        <i class="iconfont iconbookmark"></i>
                        燃气度数&ensp;
                    </div>
                    <div class="imgBody">
                        <div class="imgCard">
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsContractDetail.image.gas]">
                                <van-image width="3rem" height="3rem" :src="jzsContractDetail.image.gas" />
                            </div>
                            <div class="text">{{jzsContractDetail.contract.gas}}</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="title">
                        <i class="iconfont iconbookmark"></i>
                        合同&ensp;
                    </div>
                    <div class="imgBody">
                        <div class="imgCard" v-for="(item,index) in jzsContractDetail.image.contact" :key="index">
                            <div class="img" @click="imgShow=true;imgIndex = index;images=jzsContractDetail.image.contact;">
                                <van-image width="3rem" height="3rem" :src="item" />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="title">
                        <i class="iconfont iconbookmark"></i>
                        银行卡&ensp;
                    </div>
                    <div class="imgBody">
                        <div class="imgCard">
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsContractDetail.image.bankCard]">
                                <van-image width="3rem" height="3rem" :src="jzsContractDetail.image.bankCard" />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="title">
                        <i class="iconfont iconbookmark"></i>
                        产权&ensp;
                    </div>
                    <div class="imgBody">
                        <div class="imgCard" v-for="(item,index) in jzsContractDetail.image.property" :key="index">
                            <div class="img" @click="imgShow=true;imgIndex = index;images=jzsContractDetail.image.property;">
                                <van-image width="3rem" height="3rem" :src="item" />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="title">
                        <i class="iconfont iconbookmark"></i>
                        其他&ensp;
                    </div>
                    <div class="imgBody">
                        <div class="imgCard" v-for="(item,index) in jzsContractDetail.image.other" :key="index">
                            <div class="img" @click="imgShow=true;imgIndex = index;images=jzsContractDetail.image.other;">
                                <van-image width="3rem" height="3rem" :src="item" />
                            </div>
                        </div>
                    </div>
                </div>
            </van-tab>
            <div style="height:1.2rem;"></div>
        </van-tabs>
        <!-- 审批 -->
        <van-steps direction="vertical" :active="0" active-color="#FD7E2D" active-icon="more" inactive-icon="checked" v-if="type == 1">
            <van-step v-for="item in trackRecordList" :key="item.id">
                <!-- 开始 -->
                <div v-if="item.taskStartEndType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item.actorTime">发起时间：{{item.actorTime}}</p>
                    </div>
                </div>
                <!-- 审批 -->
                <div v-else-if="item.taskType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item1.approvalStatus">审批结果：{{approvalStatusList[item1.approvalStatus-1]}}</p>
                        <p v-if="item1.remark">审批意见：{{item1.remark}}</p>
                        <p v-if="item1.approvalTime">处理时间：{{item1.approvalTime}}</p>
                        <p v-if="item1.createTime">到达时间：{{item1.createTime}}</p>
                    </div>
                </div>
                <!-- 抄送 -->
                <div v-else-if="item.taskType == 2">
                    <div>
                        <h4>
                            <span v-for="(item1,index1) in item.actors" :key="index1">
                                <span v-if="index1!=0">/</span>
                                {{item1.actorName}}
                            </span>
                        </h4>
                        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>
                    </div>
                </div>
                <!-- 结束 -->
                <div v-else>结束</div>
            </van-step>
        </van-steps>
        <van-form ref="form" label-width="110px" input-align="left" v-if="$route.query.type == 1&&type == 1 && trackRecordList[0].status != 5">
            <van-field label="审批意见" :border="false" />
            <van-field v-model="formData.remark" rows="2" autosize type="textarea" maxlength="50" placeholder="请输入审批意见" show-word-limit :rules="[{ required: true, message: '请输入审批意见' }]" />
        </van-form>
        <div v-if="$route.query.type" style="height:1.2rem"></div>
        <div class="btn" v-if="$route.query.type">
            <van-button v-if="type == 0" @click="type = 1" type="primary">审批</van-button>
            <van-button v-if="type == 1" @click="type = 0" type="primary">详情</van-button>
            <van-button block type="primary" v-if="$route.query.type == 1&&type == 1 && trackRecordList[0].status != 5" :loading="saveLoad" :disabled="saveLoad" @click="submit(2)">驳回</van-button>
            <van-button block type="primary" v-if="$route.query.type == 1&&type == 1 && trackRecordList[0].status != 5" :loading="saveLoad" :disabled="saveLoad" @click="submit(1)">同意</van-button>
        </div>
        <!-- 资产详情 -->
        <van-dialog v-model="showAssets" title="资产详情" show-cancel-button :showConfirmButton="false" :showCancelButton="false" :closeOnClickOverlay="true" width="300">
            <van-cell title="名称" :value="asstesDetail.materialTypeName" />
            <van-cell title="品类" :value="asstesDetail.materialTypeParentName" />
            <van-cell title="规格" :value="asstesDetail.specification" />
            <van-cell title="品牌" :value="asstesDetail.brand" />
            <van-cell title="型号" :value="asstesDetail.model" />
        </van-dialog>
        <!-- 图片预览 -->
        <van-image-preview v-model="imgShow" :startPosition="imgIndex" :images="images"></van-image-preview>
        <!-- 加载 -->
        <div class="loading" v-if="loading"></div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
    requestJzsContractDetail,
    requestWorkflowDetail1,
    requestWorkflowSubmit,
     changeCompany, //钉钉消息进入详情页需切换公司 获取对应按钮权限
  requestButtomAuth,
} from "@/api";
import { mergeRowCol, accSub, formatDate, parseTime } from "@/utils/index";
export default {
    name: "jzsContractDetail",
    data() {
        return {
            active: 0,
            asstesDetail: {},
            showAssets: false,
            activeNames: [],
            jzsContractDetail: {
                community: {},
                contract: {},
                image: {
                    contract: "",
                    property: "",
                    other: ""
                },
                houseBuildingList: [],
                property: {},
                propertyReceipt: {},
                houseBuilding: []
            },
            imgShow: false,
            imgIndex: 0,
            images: [],
            //审批
            type: 0, //切换0.详情/1.审批
            saveLoad: false,
            trackRecordList: [{ status: "" }],
            loading: true,
            formData: {
                remark: ""
            }
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "destineList",
            "payList",
            "pContractStatusList",
            "customerList",
            "contactList",
            "quitTypeList",
            "contractTypeList",
            "returnOrderStatus",
            "approvalStatusList",
            "payTypeList",
            "buildingTypeList"
        ])
    },
    created() {
        this.getDetail();
        if (this.$route.query.type) {
            //待办进入
            this.getWorkflow();
        }
    },
    mounted() {},
    methods: {
        getDetail() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中..."
            });
            requestJzsContractDetail(this.$route.query.id)
                .then(res => {
                      changeCompany({ companyId: res.data.contract.companyId }).then(
                       (res) => {
                      this.$store.dispatch("resetAll", res.data);
                        requestButtomAuth().then((res) => {
                      this.$store.commit("SET_BUTTON", res.data || []);
                     });
                     }
                   );
                    res.data.image = res.data.image ? res.data.image : {};
                    res.data.image.contact = res.data.image.contact
                        ? res.data.image.contact.split(",")
                        : [];
                    res.data.image.property = res.data.image.property
                        ? res.data.image.property.split(",")
                        : [];
                    res.data.image.other = res.data.image.other
                        ? res.data.image.other.split(",")
                        : [];
                    const houseBuilding = res.data.historyHouseBuildingList
                        ? res.data.historyHouseBuildingList
                        : res.data.houseBuildingList;
                    houseBuilding.forEach(d => {
                        d.houseBuildingItems.forEach(e => {
                            const show = e.roomInfo.find(f => {
                                return (
                                    f.isSign &&
                                    res.data.contractId == f.communityContractId
                                );
                            });
                            d.show = d.show ? d.show : show;
                            e.show = show;
                        });
                    });
                    res.data.houseBuilding = houseBuilding;
                    this.jzsContractDetail = res.data;
                    this.loading = false;
                    toast1.clear();
                })
                .catch(err => {
                    toast1.clear();
                });
        },
        //查流程
        getWorkflow() {
            //审批待办
            requestWorkflowDetail1(this.$route.query.agentId).then(res => {
                this.trackRecordList = res.data ? res.data : [];
                this.trackRecordList[0].status == 5
                    ? (this.type = 1)
                    : (this.type = 0);
                // this.loading = false;
            });
        },
        accSub(num1, num2) {
            return accSub(num1, num2);
        },
        //资产详情
        lookAssets(assets) {
            this.asstesDetail = assets;
            this.showAssets = true;
        },
        //审批提交
        submit(type) {
            let param = {
                agentId: this.$route.query.agentId,
                orderId: this.$route.query.orderId,
                approvalStatus: type,
                remark: this.formData.remark
            };
            if (type == 1) {
                //同意
                this.$dialog.confirm({
                    title: "提示",
                    message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    beforeClose: (action, done) => {
                        if (action === "confirm") {
                            this.saveLoad = true;
                            requestWorkflowSubmit(param)
                                .then(res => {
                                    this.$toast.success("审批成功");
                                    this.getWorkflow();
                                    this.saveLoad = false;
                                    done();
                                })
                                .catch(err => {
                                    this.saveLoad = false;
                                    done(false);
                                });
                        } else {
                            done();
                        }
                    }
                });
            } else {
                //驳回
                this.$refs["form"].validate().then(valid => {
                    this.$dialog.confirm({
                        title: "提示",
                        message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        beforeClose: (action, done) => {
                            if (action === "confirm") {
                                this.saveLoad = true;
                                requestWorkflowSubmit(param)
                                    .then(res => {
                                        this.$toast.success("审批成功");
                                        this.getWorkflow();
                                        this.saveLoad = false;
                                        done();
                                    })
                                    .catch(err => {
                                        this.saveLoad = false;
                                        done(false);
                                    });
                            } else {
                                done();
                            }
                        }
                    });
                });
            }
        }
    },
    watch: {}
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.noData {
    line-height: 1rem;
}
.theme-color {
    color: $theme-color;
}
.tabs {
    .title {
        text-align: left;
        padding: 0.3rem 0.2rem;
        font-weight: 600;
        font-size: 0.37rem;
    }
    /deep/.van-tab {
        flex: 1;
    }
    /deep/.van-tabs__content {
        height: calc(100vh - 1.2rem);
        overflow: scroll;
    }
    .assets {
        .title {
            background-color: #fff;
        }
        .assetsBody {
            display: flex;
            justify-content: flex-start;
            background-color: #fff;
            padding: 0.2rem 0;
            flex-wrap: wrap;
            > div {
                width: 28%;
                height: 0.8rem;
                line-height: 0.8rem;
                border: 1px solid $theme-color;
                color: $theme-color;
                text-align: center;
                margin: 0 2.5% 0.1rem;
            }
        }
    }
    .orderBody {
        padding: 0 0.2rem;
        // border: 2px dashed #dadada;
        margin: 0.4rem 0;
        border-radius: 0.2rem;
        background-color: #fff;
        .orderBody-head {
            padding: 0.2rem;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid $border-color;
            .line {
                width: 1px;
                height: 0.8rem;
                transform: translateY(0.05rem);
                background: #dadada;
            }
            .name {
            }
            .text {
                font-weight: bold;
                // color: $font-deep-gray;
            }
            p {
                padding: 0.1rem 0;
            }
        }
        .orderBody-body {
            display: flex;
            padding: 0.3rem 0;
            border-bottom: 1px solid $border-color;
            .name {
                flex: 1;
                text-align: left;
                .money {
                    color: $fail-color;
                }
            }
            .success {
                color: $success-color;
            }
            .fail {
                color: $fail-color;
            }
            .pay {
                color: #fff;
                padding: 0.1rem 0.2rem;
                background: #fd7e2d;
                border-radius: 0.1rem;
            }
            .text {
                span {
                    display: inline-block;
                    width: 0.5rem;
                }
                i {
                    font-size: 0.3rem;
                }
            }
        }
        .border-b {
            border: none !important;
        }
        .details {
            color: $font-deep-gray;
            padding: 0.2rem 0;
            > div {
                display: flex;
                padding: 0.1rem;
                .name {
                    flex: 1;
                    text-align: left;
                }
            }
        }
        .blod {
            font-weight: bold;
        }
    }
    .imgBody {
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        background-color: #fff;
        padding: 0.5rem 0.2rem 0;
        border-radius: 0.2rem;
        .imgCard {
            margin: 0 0.1rem;
            .text {
                line-height: 0.8rem;
            }
        }
    }
    .imgBody1 {
        padding: 0 0.2rem;
    }
    .returnBody {
        // padding-top: 0.001rem;
        font-size: 0.35rem;
        margin-top: 0.3rem;
        .card {
            background: #fff;
            margin: 0.3rem;
            border-radius: 0.2rem;
            color: $color9;
            padding: 0.2rem 0;
            // margin: 0.2rem 0;
            p {
                text-align: left;
                display: flex;
                justify-content: space-between;
                padding: 0 0.4rem;
                line-height: 0.8rem;
                > span {
                    height: 0.8rem;
                }
                .returnBody-title {
                    font-size: 0.35rem;
                    font-weight: 600;
                    height: auto;
                    color: #000;
                    // span {
                    //     max-width: 4.5rem;
                    //     vertical-align: top;
                    //     overflow: hidden;
                    //     display: inline-block;
                    //     height: auto;
                    //     text-overflow: ellipsis;
                    // }
                    // .ellipsis {
                    //     white-space: nowrap;
                    // }
                }
                .big {
                    font-size: 0.4rem;
                }
            }
        }
        > .card:first-child {
            margin-top: 0;
        }
        .theme-color {
            color: $theme-color;
        }
    }
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        padding: 0%;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
}
.van-steps {
    text-align: left;
    padding-left: 2rem;
    /deep/.van-step__title {
        padding-left: 0.3rem;
        p {
            padding-top: 0.2rem;
        }
    }
}
.border::after,
.border1::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0;
    border-bottom: 0.02667rem solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
}
.border1::after {
    border-bottom: 0.02667rem solid #c7c7c7;
}
.van-collapse {
    /deep/.van-cell__title {
        flex: 1;
    }
}
.van-collapse-item__content {
    padding-top: 0;
}
</style>
